export const CREATE_MESSAGE = 'messages/CREATE_MESSAGE'
export const UPDATE_MESSAGE = 'messages/UPDATE_MESSAGE'
export const IMPORT_MESSAGES = 'messages/IMPORT_MESSAGES'
export const CLEAR_MESSAGES_STATE = 'messages/CLEAR_MESSAGES_STATE'
